import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Spinner from "./Spinner";
import { apiURL } from "../api";

export default function UpdateTaskSolutions() {
  const [isLoading, setIsLoading] = useState(true);
  const [taskData, setTaskData] = useState({});
  const { uuid } = useParams();

  const getTaskWithSolutions = (uuid) => {
    setIsLoading(true);
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({
        method: "task.getTaskWithSolutions",
        params: {
          uuid: uuid,
        },
      }),
    };

    fetch(apiURL + "/public", requestOptions)
      .then((response) => response.json())
      .then((response) => {
        setTaskData(response.result);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getTaskWithSolutions(uuid);
  }, [uuid]);

  return (
    <div>
      {isLoading ? (
        <Spinner />
      ) : (
        <div>
          <h3 className="my-3">Update Task Solutions</h3>
          {taskData.solutions &&
            taskData.solutions.map((solution) => (
              <Solution
                key={solution.uuid}
                taskUuid={taskData.uuid}
                solution={solution}
                getTaskWithSolutions={getTaskWithSolutions}
              />
            ))}
        </div>
      )}
    </div>
  );
}

function Solution(props) {
  const [solution, setSolution] = useState(props.solution);

  const handleUpdateTaskSolutions = (solution) => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({
        method: "solution.update",
        params: {
          uuid: solution.uuid,
          solutionNumber: solution.solutionNumber,
          text: solution.text,
          code: solution.code,
          codeLanguage: solution.codeLanguage,
        },
      }),
    };

    fetch(apiURL + "/admin", requestOptions)
      .then((response) => response.json())
      .then((response) => {
        if (response.error) {
          throw new Error(response.error.message);
        }
      })
      .catch((error) => {
        console.error("Failed to update task solution:", error);
      })
      .finally(() => {});
  };

  const handleConfirmDeleteSolution = (solution) => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({
        method: "solution.delete",
        params: {
          uuid: solution.uuid,
        },
      }),
    };

    fetch(apiURL + "/admin", requestOptions)
      .then((response) => response.json())
      .then((response) => {
        if (response.error) {
          throw new Error(response.error.message);
        }
      })
      .catch((error) => {
        console.error("Failed to delete task solution:", error);
      })
      .finally(() => {
        props.getTaskWithSolutions(props.taskUuid);
      });
  };

  return (
    <form className="mx-5">
      <div className="mb-3">
        <label
          htmlFor="taskSolutionUpdateOrderNumber"
          className="col-form-label"
        >
          Solution Number:
        </label>
        <input
          type="number"
          className="form-control"
          id="taskSolutionUpdateOrderNumber"
          value={solution.solutionNumber || ""}
          onChange={(event) =>
            setSolution({
              ...solution,
              solutionNumber: Number(event.target.value),
            })
          }
        />
      </div>
      <div className="mb-3">
        <label htmlFor="taskSolutionUpdateText" className="col-form-label">
          Text:
        </label>
        <textarea
          type="text"
          className="form-control"
          id="taskSolutionUpdateText"
          value={solution.text || ""}
          onChange={(event) =>
            setSolution({ ...solution, text: event.target.value })
          }
        ></textarea>
      </div>
      <div className="mb-3">
        <label htmlFor="taskSolutionUpdateCode" className="col-form-label">
          Code:
        </label>
        <textarea
          type="text"
          className="form-control"
          id="taskSolutionUpdateCode"
          value={solution.code || ""}
          onChange={(event) =>
            setSolution({ ...solution, code: event.target.value })
          }
        ></textarea>
      </div>
      <div className="mb-3">
        <label
          htmlFor="taskSolutionUpdateCodeLanguage"
          className="col-form-label"
        >
          Code Language:
        </label>
        <select
          className="form-select"
          aria-label="Code Language"
          id="taskSolutionUpdateCodeLanguage"
          value={solution.codeLanguage || ""}
          onChange={(event) =>
            setSolution({ ...solution, codeLanguage: event.target.value })
          }
        >
          <option value="javascript">javascript</option>
          <option value="html">html</option>
          <option value="jsx">jsx</option>
          <option value="css">css</option>
          <option value="scss">scss</option>
        </select>
      </div>

      <button
        type="button"
        className="btn btn-primary col-2 me-2"
        onClick={() => {
          handleUpdateTaskSolutions(solution);
        }}
      >
        Update
      </button>

      <button
        type="button"
        className="btn btn-danger col-2"
        title="Delete the task solution"
        data-bs-target="#deleteTaskSolution"
        onClick={() => {
          handleConfirmDeleteSolution(solution);
        }}
      >
        Delete
      </button>
    </form>
  );
}
